import { __assign } from "tslib";
/* eslint-disable @typescript-eslint/no-unnecessary-type-constraint */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react';
import { ThemeProvider as MuiThemeProvider, createTheme as createThemeMui } from '@mui/material/styles';
import GlobalTheme from './global';
import { ThemeModes } from './variables';
var getCustomTheme = function (ct) {
    /* istanbul ignore next */
    var theme = !ct.mode || ct.mode === ThemeModes.Light ? ct.light : ct.dark || ct.light;
    return createThemeMui(theme);
};
export var withTheme = function (Component) {
    var Wrapper = function (props) {
        var customTheme = props.theme;
        /**
         * Priority: Custom Theme -> Global Theme -> defaultTheme
         */
        var _a = useState(customTheme ? getCustomTheme(customTheme) : GlobalTheme.getTheme()), theme = _a[0], setTheme = _a[1];
        /**
         * Logic for Global Theme set initially in whole app by using previusly GlobalTheme.init()
         */
        useEffect(function () {
            var id = !customTheme && GlobalTheme.isLoaded
                ? GlobalTheme.register(function () {
                    setTheme(GlobalTheme.getTheme());
                })
                : undefined;
            return function () { return GlobalTheme.unregister(id); };
        }, []);
        /**
         * Logic for Custom Theme passed as props
         */
        useEffect(function () {
            if (customTheme) {
                setTheme(getCustomTheme(customTheme));
            }
        }, [customTheme]);
        /* istanbul ignore next */
        var testProps = process.env.NODE_ENV === 'test' ? { theme: theme } : {};
        return (React.createElement(MuiThemeProvider, { theme: theme },
            React.createElement(Component, __assign({}, props, testProps))));
    };
    return Wrapper;
};
export default withTheme;
//# sourceMappingURL=withTheme.hoc.js.map